import React from 'react';
import { blogPosts } from '../mock';
import { Card } from './ui/card';
import { Clock, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import './Blog.css';

const Blog = () => {
  const featuredPosts = blogPosts.filter(post => post.featured);
  const regularPosts = blogPosts.filter(post => !post.featured);

  return (
    <section id="blog" className="blog-section">
      <div className="blog-container">
        <div className="blog-header">
          <span className="section-label">Insights</span>
          <h2 className="section-title">Latest Analysis & Commentary</h2>
          <p className="section-description">
            Expert perspectives on emerging policy trends and regulatory developments
          </p>
        </div>

        {/* Featured Posts */}
        {featuredPosts.length > 0 && (
          <div className="featured-posts">
            {featuredPosts.map((post) => (
              <Card key={post.id} className="featured-post-card">
                <div className="featured-image-wrapper">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="featured-image"
                  />
                  <div className="featured-badge">Featured</div>
                </div>
                <div className="featured-content">
                  <div className="post-meta">
                    <span className="post-category">{post.category}</span>
                    <span className="post-date">{post.date}</span>
                  </div>
                  <h3 className="featured-title">{post.title}</h3>
                  <p className="featured-excerpt">{post.excerpt}</p>
                  <div className="post-footer">
                    <div className="post-read-time">
                      <Clock size={16} />
                      <span>{post.readTime}</span>
                    </div>
                    <Button
                      onClick={() => window.open(post.link, '_blank')}
                      className="read-more-button"
                    >
                      Read Article <ArrowRight size={16} />
                    </Button>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        )}

        {/* Regular Posts */}
        {regularPosts.length > 0 && (
          <div className="regular-posts">
            {regularPosts.map((post) => (
              <Card key={post.id} className="regular-post-card">
                <img
                  src={post.image}
                  alt={post.title}
                  className="post-image"
                />
                <div className="post-content">
                  <div className="post-meta">
                    <span className="post-category">{post.category}</span>
                    <span className="post-date">{post.date}</span>
                  </div>
                  <h3 className="post-title">{post.title}</h3>
                  <p className="post-excerpt">{post.excerpt}</p>
                  <div className="post-footer">
                    <div className="post-read-time">
                      <Clock size={16} />
                      <span>{post.readTime}</span>
                    </div>
                    <Button
                      onClick={() => window.open(post.link, '_blank')}
                      className="read-more-button-small"
                    >
                      Read <ArrowRight size={14} />
                    </Button>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Blog;
